





















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ChatForSurvivors from "@/components/ChatForSpecificPlayers/ChatForSurvivors.vue";
import ChatForJinro from "@/components/ChatForSpecificPlayers/ChatForJinro.vue";
import ChatForKilledPlayers from "@/components/ChatForSpecificPlayers/ChatForKilledPlayers.vue";
import ChatForRoom from "@/components/ChatForSpecificPlayers/ChatForRoom.vue";
import { JinroRoles } from "@/services/jinro-roles";
import { JinroPlayStatus } from "@/services/jinro-play-status";

@Component({
  components: {
    ChatForSurvivors,
    ChatForJinro,
    ChatForKilledPlayers,
    ChatForRoom,
  },
})
export default class JinroGameChat extends Vue {
  @Prop() readonly jinroGameId!: string;
  @Prop() readonly jinroRoomId!: string;

  get isPublicViewing(): boolean {
    // public view path example:  /j/TAYBteCF9uJnFVyUtP8W/public
    const elmnts = this.$route.path.split("/");

    return elmnts.length > 3 && this.$route.path.split("/")[3] === "public";
  }

  get isShowableJinroRoomChat(): boolean {
    if (!this.jinroGameId) {
      return true;
    }
    if (this.isPlayStatusEnding) {
      return true;
    }
    if (this.isPlayStatusPrologue) {
      return true;
    }
    return false;
  }

  get isPlayerJinro(): boolean {
    if (this.$store.state.jinroPlayerGame) {
      return this.$store.state.jinroPlayerGame.role === JinroRoles.Jinro;
    }

    return false;
  }

  get isKilled(): boolean {
    if (this.$store.state.jinroPlayerGame) {
      const that = this.$store.state.jinroPlayerGame;
      return !!that.isKilled;
    } else {
      return false;
    }
  }

  get isPlayStatusNight(): boolean {
    if (this.playStatus) {
      return this.playStatus === JinroPlayStatus.Night;
    } else {
      return false;
    }
  }
  get isPlayStatusEnding(): boolean {
    if (this.playStatus) {
      return this.playStatus === JinroPlayStatus.Ending;
    } else {
      return false;
    }
  }

  get isPlayStatusPrologue(): boolean {
    if (this.playStatus) {
      return this.playStatus === JinroPlayStatus.Prologue;
    } else {
      return false;
    }
  }

  get playStatus(): string {
    if (this.$store.state.jinroGamePlayinfo) {
      const that = this.$store.state.jinroGamePlayinfo;
      return that.playStatus;
    }
    return "";
  }
}
